import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d5e4152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-unbound__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "stake-unbound__title" }, "Unbound", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "stake-unbound__description" }, " Bonded assets can be unbond at any time, but unbonding takes 28 days. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "stake-unbound__label" }, "Amount to unbond", -1))

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import ButtonsBlock from "@/components/buttons-block/index.vue";
import BaseButton from "@/components/base-button/index.vue";
import BackButton from "@/components/back-button/index.vue";
import AmountInput from "@/components/amount-input/index.vue";
import FeeInfo from "@/components/fee-info/index.vue";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  accounts,
  apiPromise,
  nativeBalances,
  nativeToken,
  selectedNetwork,
} from "@/stores";
import { Account } from "@/types/account";
import { loadStakerState } from "@/utils/staking";
import BigNumber from "bignumber.js";
import { fromBase, isValidDecimals, toBase } from "@/utils/units";
import { toBN } from "web3-utils";
import { getGasFeeInfo } from "@/utils/fee";
import { GasFeeInfo } from "@/types/transaction";
import { unbondExtrinsic } from "@/utils/extrinsic";
import { useGetNativeBalances } from "@/libs/balances";
import { useGetNativePrice } from "@/libs/prices";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const amount = ref<number>(0);
const fee = ref<GasFeeInfo>();
const fromAccount = ref<Account>();
const stakedBalance = ref<BigNumber>(new BigNumber(0));
const hasEnough = ref(true);

onMounted(() => {
  if (route.query.address) {
    const found = accounts.value.find(
      (item) => item.address === route.query.address
    );
    if (found) {
      fromAccount.value = found;
      updateStakedAmount();
      useGetNativeBalances();
      useGetNativePrice();
      return;
    }
  }
  router.push({ name: "stake" });
});

const updateStakedAmount = async () => {
  if (!fromAccount.value) {
    return;
  }

  const api = await apiPromise.value;
  const stakerState = await loadStakerState(api, fromAccount.value.address);

  if (!stakerState?.stakingLedger) {
    return;
  }

  stakedBalance.value = new BigNumber(
    fromBase(
      stakerState.stakingLedger.active.unwrap().toString(),
      nativeToken.value.decimals
    )
  );
};

watch([selectedNetwork], () => {
  updateStakedAmount();
  useGetNativeBalances();
  useGetNativePrice();
});

watch(accounts, () => {
  router.push({
    name: "stake",
  });
});

// Update fees values
watch(
  [amount, stakedBalance],
  async () => {
    if (!amount.value || !fromAccount.value?.address) {
      return;
    }

    if (!isValidDecimals(amount.value.toString(), nativeToken.value.decimals)) {
      hasEnough.value = false;
      return;
    }

    const api = await apiPromise.value;

    const rawAmount = toBN(
      toBase(amount.value?.toString() || "0", nativeToken.value.decimals)
    );

    const rawBalance = toBN(
      toBase(stakedBalance.value?.toString() || "0", nativeToken.value.decimals)
    );

    if (rawAmount.gt(rawBalance)) {
      hasEnough.value = false;
    } else {
      hasEnough.value = true;
    }

    const tx = await unbondExtrinsic(api, rawAmount.toString());

    fee.value = await getGasFeeInfo(tx, fromAccount.value.address);
  },
  { deep: true }
);

const isValid = computed<boolean>(() => {
  return (
    (Number(amount.value) > 0 &&
      hasEnough.value &&
      fee.value?.nativeValue.lte(
        nativeBalances[
          fromAccount.value?.address || ""
        ]?.available.toString() || "0"
      )) ||
    false
  );
});

const nextAction = () => {
  router.push({
    name: "stake-unbound-confirm",
    query: {
      address: fromAccount.value?.address || "",
      amount: amount.value.toString(),
    },
  });
};

const back = () => {
  router.go(-1);
};

const inputAmount = (newVal: string) => {
  amount.value = Number(newVal);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WhiteWrapper, { class: "stake-unbound__wrap" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BackButton, { action: back }),
        _hoisted_2
      ]),
      _hoisted_3,
      _hoisted_4,
      _createVNode(AmountInput, {
        "has-enough-balance": hasEnough.value,
        token: _unref(nativeToken),
        value: String(amount.value),
        "max-value": stakedBalance.value,
        "onUpdate:amount": inputAmount
      }, null, 8, ["has-enough-balance", "token", "value", "max-value"]),
      _createVNode(FeeInfo, { fee: fee.value }, null, 8, ["fee"]),
      _createVNode(ButtonsBlock, null, {
        default: _withCtx(() => [
          _createVNode(BaseButton, {
            title: "Continue",
            action: nextAction,
            send: true,
            disabled: !isValid.value
          }, null, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})